export default __webpack_public_path__ + "static/media/fkpage.9eb81ca1.JPG";